import { useMe } from '@/hooks/use-me';
import { cls } from '@/utils/cls';
import { powerLabels } from '@/utils/format/battery';

export function PowerSuffix({ className }: { className?: string }) {
  const me = useMe();

  return (
    <div className={cls('text-sm text-gray-700', className)}>
      {powerLabels[me.config.powerUnit]}
    </div>
  );
}
